<!--
    描述：编码管理子页面
    时间：2020-07-30
    Created by yefan
-->
<template>
	<div class="w-table-layout w-table-page">
		<div class="list-wrap w-table-content"
			 ref="sysCodeContent">
			<el-table v-loading="sysCodeData.loading"
					  :data="sysCodeData.tableData"
					  :border="true"
					  :height="sysCodeData.tableH"
					  ref="sysCodeTable"
					  highlight-current-row>
				<el-table-column type="index"
								 align="center"
								 width="50"></el-table-column>
				<el-table-column label="操作"
								 align="center"
								 show-overflow-tooltip
								 width="80">
					<template slot-scope="scope">
						<el-button size="mini"
								   icon="el-icon-delete"
								   title="删除"
								   type="text"
								   @click="doDelete(scope.row)"></el-button>
					</template>
				</el-table-column>
				<el-table-column prop="tag"
								 align="center"
								 label="规则类型"
								 show-overflow-tooltip
								 min-width="80"></el-table-column>
				<el-table-column prop="detail"
								 align="center"
								 label="规则"
								 show-overflow-tooltip
								 min-width="120"></el-table-column>
				<el-table-column prop="company"
								 show-overflow-tooltip
								 align="center"
								 label="适用单位"
								 min-width="240"></el-table-column>
				<el-table-column prop="createUserName"
								 align="center"
								 label="创建人"
								 show-overflow-tooltip
								 min-width="80"></el-table-column>
				<el-table-column prop="createDate"
								 align="center"
								 label="创建日期"
								 show-overflow-tooltip
								 min-width="100"></el-table-column>
				<el-table-column prop="startDate"
								 align="center"
								 label="启用日期"
								 show-overflow-tooltip
								 min-width="80"></el-table-column>
			</el-table>
		</div>

		<div class="w-table-footer">
			<el-pagination @size-change="handleSizeChange"
						   @current-change="handleCurrentChange"
						   :current-page="sysCodeData.currentPage"
						   :page-sizes="sysCodeData.pageList"
						   :page-size="sysCodeData.pageSize"
						   layout="total, sizes, prev, pager, next, jumper"
						   :total="sysCodeData.total"></el-pagination>
		</div>

		<!-- 新增、编辑等弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   :close-on-click-modal="false">
			<!-- 弹窗组件 -->
			<addCodeDialog ref="addCode"
						   v-if="dialogObj.visible"
						   @on-success="addCode"></addCodeDialog>
			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center">
				<el-button size="small"
						   @click="dialogObj.visible = false">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doSave">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import addCodeDialog from './add_code_dialog'
import { selectCodeAll, deleteCode } from 'api/system/sys.js'

export default {
	components: { addCodeDialog },
	props: {
		searchObj: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data() {
		return {
			transObj: {
				id: '',
				parentId: '',
				parentName: '',
				type: ''
			},
			sysCodeData: {
				loading: false,
				pageSize: 10,
				currentPage: 1,
				total: 0,
				tableH: 0,
				tableData: [],
				pageList: [10, 20, 50, 100] // 显示条数数组
			},
			btnLoading: false,
			dialogObj: {
				title: '新增编码规则',
				visible: false,
				width: '680px',
				mode: 'add'
			}
		}
	},

	methods: {
		getTablePageList() {
			let param = {
				tag: this.searchObj.tag,
				company: this.searchObj.company,
				startDate: this.searchObj.startDate,
				current: this.sysCodeData.currentPage,
				size: this.sysCodeData.pageSize
			}
			selectCodeAll(param).then(res => {
				if (res.operationCode == 1) {
					this.shiftJosn(res.data.records)
					this.sysCodeData.total = parseInt(res.data.total)
				}
			})
		},

		shiftJosn(thisArr) {
			//当表格请求的字符串由数组转换为json格式
			var needJson = ''
			var testArr = []
			var testArrGet = []
			var zhongArr = []
			for (var i = 0; i < thisArr.length; i++) {
				testArr = eval('(' + thisArr[i].detail + ')')
				testArrGet = []
				for (var j = 0; j < testArr.length - 1; j++) {
					testArrGet.push(testArr[j].type)
					testArrGet.push(testArr[j].connector)
				}
				testArrGet.push(testArr[testArr.length - 1].serialNo)
				needJson = testArrGet.join('')
				zhongArr.push(needJson)
				thisArr[i].detail = zhongArr[i]
			}
			this.sysCodeData.tableData = thisArr
		},

		// 新增按钮点击事件
		doClick() {
			this.dialogObj.visible = true
		},

		// 删除按钮点击事件
		doDelete(row) {
			this.$confirm('是否确定删除当前编码规则?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				deleteCode({ id: row.id }).then(res => {
					res.operationCode == 1
						? this.$message.success('删除成功！')
						: this.$message.error(res.msg)
					this.getTablePageList()
				})
			})
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.sysCodeData.pageSize = val
			this.getTablePageList()
		},

		// 切换当前页码
		handleCurrentChange(cur) {
			this.sysCodeData.currentPage = cur
			this.getTablePageList()
		},

		// 确定按钮事件
		doSave() {
			this.$refs.addCode.doSave()
		},

		// 保存成功回调
		addCode() {
			this.dialogObj.visible = false
			this.getTablePageList()
		}
	},
	watch: {
		clientSize(val) {
			this.sysCodeData.tableH = this.$refs.sysCodeContent.offsetHeight
		}
	},
	created() {
		this.getTablePageList()
	},

	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.sysCodeData.tableH = this.$refs.sysCodeContent.offsetHeight
			}, 100)
		})
	}
}
</script>